// extracted by mini-css-extract-plugin
export default {"closed":"GetHelp_closed__HUrlp","view":"GetHelp_view__nBV8G"};